import { render, staticRenderFns } from "./SuccessAndErrorsTable.vue?vue&type=template&id=47ea51b2"
import script from "./SuccessAndErrorsTable.vue?vue&type=script&lang=js"
export * from "./SuccessAndErrorsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports